import { copy } from "shared/assets";
import { IFieldType, IFormFields } from "shared/types";

const { errors } = copy;
const propsCopy = copy.adminDashboard.editTrial;

export const fields: IFormFields = [
  {
    name: "start",
    label: propsCopy.startDate,
    type: IFieldType.simpleDate,
    validation: {
      required: errors.required,
    },
  },
  {
    name: "stop",
    label: propsCopy.endDate,
    type: IFieldType.simpleDate,
    validation: {
      required: errors.required,
    },
  },
];
